import { Stack as BaseStack } from '@mui/material';

import type { StackProps } from '@mui/material/Stack';

export default function Stack(props: StackProps) {
  return <BaseStack {...props} />;
}
